import axiosInstance from '../../components/api/axiosInstance';

export const userService = {
  getUsers: (params = {}, { signal } = {}) =>
    axiosInstance.get('/api/business/users', { params, signal }).then((r) => r.data),

  createUser: (userData) =>
    axiosInstance.post('/api/business/users', userData).then((r) => r.data),

  checkUser: (username, domain) =>
    axiosInstance.post('/api/business/users/check-user', { username, domain }).then((r) => r.data),

  checkUsername: (username) =>
    axiosInstance.post('/api/business/users/check-username', { username }).then((r) => r.data),

  resetPassword: (userId, password, requireChange = true) =>
    axiosInstance.post(`/api/business/users/${userId}/reset-password`, { password, requireChange }).then((r) => r.data),

  bulkDelete: (userIds) =>
    axiosInstance.post('/api/business/users/bulk-delete', { userIds }).then((r) => r.data),

  bulkUpload: (formData) =>
    axiosInstance.post('/api/business/users/bulk-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data),

  getBulkUploadTemplate: () =>
    axiosInstance.get('/api/business/users/bulk-upload/template', {
      responseType: 'blob',
    }).then((r) => r.data),

  assignRole: (userId, roleId) =>
    axiosInstance.post(`/api/business/users/${userId}/assign-role`, { roleId }).then((r) => r.data),

  blockUser: (userId) =>
    axiosInstance.post(`/api/business/users/${userId}/block`).then((r) => r.data),

  unblockUser: (userId) =>
    axiosInstance.post(`/api/business/users/${userId}/unblock`).then((r) => r.data),

  updateUser: (userId, userData) =>
    axiosInstance.put(`/api/business/users/${userId}`, userData).then((r) => r.data),

  deleteUser: (userId) =>
    axiosInstance.delete(`/api/business/users/${userId}`).then((r) => r.data),
};
